import { AxiosResponse } from 'axios';
import { CovenantDTO } from '../types/Convenant.d';
import apiBack from './api';

export class CovenantService {
  static async createCovenant(covenant: CovenantDTO): Promise<AxiosResponse> {
    const response = await apiBack.post('/covenants', covenant);
    return response;
  }

  static async findByNumber(number: string): Promise<AxiosResponse> {
    const response = await apiBack.get('/covenants/', {
      params: { number },
      validateStatus: status => [200, 404].includes(status),
    });
    return response;
  }

  static async updateCovenant(covenant: CovenantDTO): Promise<AxiosResponse> {
    const response = await apiBack.put(`/covenants/${covenant.id}`, covenant);
    return response;
  }

  static async findPerson(siape: string | undefined, name: string | undefined): Promise<AxiosResponse> {
    const response = await apiBack.get('/persons/', {
      params: { siape, name },
      validateStatus: status => [200, 404].includes(status),
    });
    return response;
  }

  static async findPersonById(coordinatorId: number): Promise<AxiosResponse> {
    const response = await apiBack.get(`/persons/${coordinatorId}`, {
      validateStatus: status => [200, 404].includes(status),
    });
    return response;
  }
}
